import { render } from "./SalesReportChart.vue?vue&type=template&id=510dfd82&scoped=true&ts=true"
import script from "./SalesReportChart.vue?vue&type=script&lang=ts"
export * from "./SalesReportChart.vue?vue&type=script&lang=ts"

import "./SalesReportChart.vue?vue&type=style&index=0&id=510dfd82&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510dfd82"]])

export default __exports__